require("@rails/ujs").start();
require("turbolinks").start();

const images = require.context("../images", true);

// Bootstrap の JS (ヘッダーの開閉 collapse、カテゴリメニューの dropdown など data-bs-toggle で動く部品) を読み込む
import "bootstrap";
import "./bootstrap_custom.js";
import "@fortawesome/fontawesome-free/js/all";
import "../stylesheets/application.scss";


$(document).on("turbolinks:load", function () {
  $("#searchbox").on("shown.bs.collapse", function () {
    $("#q_doc_cont_all").focus();
  });
});
